const KEY = "$uper$ecretKEYthingy1992!";
const ACTIVE = true;

const sendBreezeAttendance = (personID, firstName, lastName, date, isSelected) => {
    if(!ACTIVE){
        return;
    }

    let postData = new FormData();
    postData.append('key', KEY);
    postData.append('command', 'ATTENDANCE');
    postData.append('data', JSON.stringify({
        breeze_person_id: personID,
        firstName: firstName,
        lastName: lastName,
        date: date,
        newCheckInStatus: !isSelected
    }));

    fetch('https://calvaryokc.church/appthing.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json' // Specify the content type as JSON
        },
        body: postData,
    }).then(res => res.text());
}

const sendBreezeNewPerson = (personData) => {
    if(!ACTIVE){
        return;
    }

    let postData = new FormData();
    postData.append('key', KEY);
    postData.append('command', 'NEW PERSON');
    postData.append('data', JSON.stringify(personData));

    // fetch('https://calvaryokc.church/appthing.php', {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json' // Specify the content type as JSON
    //     },
    //     body: postData,
    // }).then(res => res.text());
}


const sendBreezeUpdatePerson = (updatedPersonData) => {
    if(!ACTIVE){
        return;
    }

    let postData = new FormData();
    postData.append('key', KEY);
    postData.append('command', 'UPDATE PERSON');
    postData.append('data', JSON.stringify(updatedPersonData));

    // fetch('https://calvaryokc.church/appthing.php', {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json' // Specify the content type as JSON
    //     },
    //     body: postData,
    // }).then(res => res.text());
}


export {
    sendBreezeAttendance,
    sendBreezeNewPerson,
    sendBreezeUpdatePerson
}